var map = {
	"./Delivery_App_SS2.jpg": 8981,
	"./DigiSamvaad_logo.jpg": 5214,
	"./FreshNest_logo.jpg": 233,
	"./Hawa_Mahal.jpg": 8760,
	"./MySQL_Logo.png": 7866,
	"./Netflix_SS8.png": 3512,
	"./Nextjs_Logo.png": 2772,
	"./NodeJS_Logo.jpg": 331,
	"./PicNest_logo.jpg": 9774,
	"./SRMS_logo.jpg": 8858,
	"./SS4.jpg": 4809,
	"./SkillNest_logo.jpg": 8480,
	"./SwaadSansaar_logo.jpg": 7825,
	"./TicTacToe.png": 4408,
	"./aws_logo.png": 9737,
	"./css.jpg": 6728,
	"./docker_logo.png": 7905,
	"./expressjs_logo.png": 9694,
	"./figma_logo.png": 852,
	"./firebase.png": 2795,
	"./flutter.png": 9453,
	"./gplaystore.png": 1897,
	"./gtc2.jpeg": 628,
	"./html.jpg": 2128,
	"./js.jpeg": 1408,
	"./jsonserver.jpg": 8829,
	"./mongodb_logo.png": 2050,
	"./quiz-logo.jpg": 8775,
	"./react-logo.jpg": 4415,
	"./socket_logo.png": 6657,
	"./todo.jpeg": 8396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5773;